import Avatar from "@material-ui/core/Avatar";
import { ReactComponent as CheckboxIcon } from "assets/icons/CheckboxIcon.svg";
import { ReactComponent as PrintIcon } from "assets/icons/print_yah.svg";
import { MyCheckbox } from "components";
import React from "react";
import "./MournerItem.scss";


const MournerItem = ({
  key,
  id,
  item,
  profile_img,
  email,
  full_name,
  first_name,
  last_name,
  values,
  setFieldValue,
  loading,
  imageLoading,
  selectedMourners,
  printHandler
}) => {

  const handleAddMourner = (item) => {
    const mournerWithEmail = selectedMourners?.filter(
      (item) => item?.member_id?.email_address || item?.email
    );
    const mournerChecked = mournerWithEmail?.filter(
      (mo) =>
        mo?.member_id?._id === item?.member_id?._id || mo?.email === item?.email
    );
    setFieldValue("recipients", [...values?.recipients, item]);
    setFieldValue("mournerWithEmail", [
      ...values?.mournerWithEmail,
      item,
    ]);
  };



  return (
    <div className="mourner_item" key={key}>
      <div className="mourner_info">
        <Avatar src={profile_img} alt={full_name} className="mourner_avatar">
          {first_name &&
            last_name &&
            (first_name[0] + last_name[0]).toString().toUpperCase()}
        </Avatar>
        <div className="info">
          <div className="name">{full_name}</div>
          {email && <div className="email">{email}</div>}
        </div>
      </div>
      {email ? (
        <div className="mourner_checkbox">
          <MyCheckbox
            checked={
              values?.recipients?.length > 0 &&
              values?.recipients?.findIndex((item) => item?._id === id) !== -1
            }
            handlechange={(e) => {
              if (e.target.checked) {
                handleAddMourner(item);
              } else {
                setFieldValue(
                  "recipients",
                  values?.recipients?.filter(
                    (rec) =>
                      rec?._id !== id
                  )
                );
                setFieldValue(
                  "mournerWithEmail",
                  values?.mournerWithEmail?.filter(
                    (item) => item?._id !== id
                  )
                );
              }
            }}
          />
        </div>
      ) : (
        <div className="mourner_print">
          {values?.printed?.length > 0 ? (
            values?.printed?.findIndex((item) => item === id) !== -1 ? (
              <div className="printed">
                <CheckboxIcon className="mr-2" /> Printed!
              </div>
            ) : (
              <div className="print">
                {loading || imageLoading ? (
                  <div
                    className="spinner-border spinner-border-sm text-primary"
                    role="status"
                  />
                ) : (
                  <>
                    <div
                      onClick={() => printHandler({item, type: "item"})}
                    >
                      <PrintIcon className="mr-3" />
                      Print
                    </div>
                  </>
                )}
              </div>
            )
          ) : (
            <div className="print">
              {loading || imageLoading ? (
                <div
                  className="spinner-border spinner-border-sm text-primary"
                  role="status"
                />
              ) : (
                <>
                  <div onClick={() => printHandler({item, type: "item"})}>
                    <PrintIcon className="mr-3" />
                    Print
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MournerItem;
